package team.platforma.chat_data.repository.chats

import kotlinx.coroutines.flow.Flow
import team.platforma.chat_data.database.chats.ChatsTable
import team.platforma.chat_data.database.draft.DraftTable
import team.platforma.chat_data.model.ChatData
import team.platforma.chatdata.table.Draft

class ChatsRepositoryImpl(
    private val chatsTable: ChatsTable
) : ChatsRepository {
    override suspend fun insertChat(chat: ChatData) {
        chatsTable.insertChat(chat)
    }

    override fun observeAiChats(aiModelID: Long?, userID: Long): Flow<List<ChatData>> = chatsTable.observeAiChats(aiModelID, userID)

}